var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconfaSolidDove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 99.46,
    viewBox: "0 0 100 99.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-dove",
    "data-name": "Icon fa-solid-dove",
    d: "M31.4,18.5a38.227,38.227,0,0,0,9.669,8.243,53.208,53.208,0,0,0,15.177,6.173V26.76a38.322,38.322,0,0,1-7.7-21.643A5.016,5.016,0,0,0,44.959.351a4.007,4.007,0,0,0-4.1,1.133A56.718,56.718,0,0,0,31.4,18.517Zm31.1,9.278v12.5c-11.876-1-36.136-8.556-42.836-30.706A5.019,5.019,0,0,0,14.956,5.9a4.005,4.005,0,0,0-3.672,2.149c-2.149,4.473-5.04,13.5-5.04,25.979,0,22.834,15.646,35.257,23.127,39.613L2.3,81.023A3.112,3.112,0,0,0,.169,83.016a3.18,3.18,0,0,0,.449,2.891c3.614,4.805,14.474,13.751,30.628,13.751a3.091,3.091,0,0,0,1.953-.684L47.967,87.157H62.5A31.245,31.245,0,0,0,93.753,55.9V24.65l5.84-8.77a2.474,2.474,0,0,0,.41-1.328,2.4,2.4,0,0,0-2.4-2.4H78.126A15.622,15.622,0,0,0,62.5,27.776ZM78.126,24.65A3.125,3.125,0,1,1,75,27.776,3.125,3.125,0,0,1,78.126,24.65Z",
    transform: "translate(-0.004 -0.198)",
    fill: "#fefefe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfaSolidDove);
export default __webpack_public_path__ + "static/media/Icon fa-solid-dove.6c4291c114f5eb3246d61fcaca874fce.svg";
export { ForwardRef as ReactComponent };